import React from 'react';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { useIntl } from 'react-intl';
import GuestBillingInformation from './GuestBillingInformation';
import HostBillingInformation from './HostBillingInformation';
import CurrencyConverter from '../../../CurrencyConverter/CurrencyConverter';
import renderTooltip from '../../../../components/siteadmin/SiteSettingsForm/toolTipHelper.js';
import { getBillingDetails } from '../../../../helpers/Pricing/getBillingDetails.js';
import messages from '../../../../locale/messages.js';

//Styles
import cs from '../../../../components/commonStyle.css';
import s from '../ViewReservation.css';

const BillingInformation = ({ data }) => {
    const { formatMessage } = useIntl();
    let refundToGuest = 0, refundCurrency, payoutToHost = 0, payoutCurrency;
    const { dayDifference, dayPrice, isAverage, guestTotal, isSpecialPricingAssigned, hostTotal } = getBillingDetails({
        checkIn: data?.checkIn, checkOut: data?.checkOut,
        bookingSpecialPricing: data?.bookingSpecialPricing,
        basePrice: data?.basePrice, total: data?.total, guestServiceFee: data?.guestServiceFee, hostServiceFee: data?.hostServiceFee, petFee: data?.petFee
    });

    if (data?.cancellationDetails) {
        refundToGuest = data?.cancellationDetails?.refundToGuest;
        payoutToHost = data?.cancellationDetails?.payoutToHost;
        payoutCurrency = data?.cancellationDetails?.currency;
        refundCurrency = data?.cancellationDetails?.currency;
    } else if (data) {
        payoutToHost = hostTotal;
        payoutCurrency = data?.currency;
        refundCurrency = data?.currency;
        if (!data?.cancellationDetails && (data?.reservationState == 'expired' || data?.reservationState == 'declined')) {
            refundToGuest = guestTotal;
        }
    }

    const pricingInformation = () => {
        return (
            <div className={cx(cs.displayFlex, cs.alignCenter, cs.gap4, cs.flexWrap)}>
                <div className={cx(cs.displayFlex, cs.alignFlexStart, cs.gap4)}>
                    {
                        isSpecialPricingAssigned &&
                        <>{renderTooltip(formatMessage(messages.averagePricePerNight), 'reservationTooltipIcon')}</>
                    }
                    <CurrencyConverter
                        amount={dayPrice}
                        from={data?.currency}
                    />
                </div>
                <div className={s.secondaryTextColor}>
                    (<CurrencyConverter
                        amount={isAverage}
                        from={data?.currency}
                    />
                    <span className={cs.displayInlineBlock}>&nbsp;{'x'}&nbsp;</span>
                    <span className={cs.displayInlineBlock}>{dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)})</span>
                </div>
            </div>
        )
    }


return (
    <div>
        <GuestBillingInformation
            cleaningPrice={data?.cleaningPrice || 0}
            convertCurrency={data?.currency}
            discount={data?.discount || 0}
            discountType={data?.discountType}
            serviceFee={data?.guestServiceFee}
            taxPrice={data?.taxPrice}
            taxValue={data?.taxValue}
            total={guestTotal}
            pricingData={pricingInformation}
            refundCurrency={refundCurrency}
            refundToGuest={refundToGuest}
            serviceFeeType={data?.guestServiceFeeType}
            serviceFeeValue={data?.guestServiceFeeValue}
            petFee={data?.petFee || 0}
        />
        <HostBillingInformation
            cleaningPrice={data?.cleaningPrice || 0}
            convertCurrency={data?.currency}
            discount={data?.discount || 0}
            discountType={data?.discountType}
            serviceFee={data?.hostServiceFee}
            taxPrice={data?.taxPrice}
            taxValue={data?.taxValue}
            total={hostTotal}
            serviceFeeType={data?.hostServiceFeeType}
            serviceFeeValue={data?.hostServiceFeeValue}
            pricingData={pricingInformation}
            payoutCurrency={payoutCurrency}
            payoutToHost={payoutToHost}
            petFee={data?.petFee || 0}
        />
    </div>
)
}

export default injectIntl(withStyles(cs, s)(BillingInformation));